export default __webpack_public_path__ + "static/media/homeInsurance-first-layer.34c1b1d1.jpg";